import React from 'react';
import { Create, SimpleForm, TextInput, required } from 'react-admin';

export default props => (
  <Create {...props} title="Cadastrar nova regra de sorteio">
    <SimpleForm sx={{ maxWidth: 600 }}>
      <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
      <TextInput source="label" label="Descrição" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
    </SimpleForm>
  </Create>
);
